// web-helper/src/components/MobileNav.jsx
import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { CompudoptLogo } from '../shared';

const MobileNav = ({ isOpen, onClose, language = 'en' }) => {
  const translations = {
    en: {
      home: 'Home',
      localAssistant: 'Local Assistant',
      webAssistant: 'Web Assistant',
      admin: 'Admin Dashboard',
      help: 'Get Help',
      about: 'About Compudopt',
      close: 'Close Menu',
    },
    es: {
      home: 'Inicio',
      localAssistant: 'Asistente Local',
      webAssistant: 'Asistente Web',
      admin: 'Panel de Administracion',
      help: 'Obtener Ayuda',
      about: 'Acerca de Compudopt',
      close: 'Cerrar Menu',
    },
  };

  const t = (key) => translations[language]?.[key] || translations.en[key];

  // Swipe-to-close gesture
  const touchStartX = useRef(0);

  const handleDrawerTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleDrawerTouchEnd = (e) => {
    const deltaX = e.changedTouches[0].clientX - touchStartX.current;
    if (deltaX < -80) {
      // Swiped left by 80px -- close the drawer
      onClose();
    }
  };

  if (!isOpen) return null;

  const navLinkStyle = {
    padding: 'var(--space-4) var(--space-5)',
    color: 'var(--text-primary)',
    textDecoration: 'none',
    fontSize: 'var(--text-lg)',
    fontWeight: 'var(--font-medium)',
    minHeight: '48px',
    display: 'flex',
    alignItems: 'center',
  };

  return (
    <>
      {/* Overlay */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          zIndex: 2000,
          opacity: isOpen ? 1 : 0,
          transition: 'opacity 0.3s ease',
        }}
      />

      {/* Drawer */}
      <div
        onTouchStart={handleDrawerTouchStart}
        onTouchEnd={handleDrawerTouchEnd}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '80%',
          maxWidth: '320px',
          height: '100%',
          background: 'var(--bg-primary)',
          boxShadow: '4px 0 24px rgba(0, 0, 0, 0.2)',
          zIndex: 2001,
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',
          transition: 'transform 0.3s ease',
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: 'var(--space-5)',
            borderBottom: '1px solid var(--border-default)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <CompudoptLogo size={32} showText={true} />
          <button
            onClick={onClose}
            aria-label={t('close')}
            className="mobile-nav-link"
            style={{
              minWidth: '44px',
              minHeight: '44px',
              width: '44px',
              height: '44px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: 'var(--text-primary)',
              fontSize: 'var(--text-2xl)',
              borderRadius: '50%',
            }}
          >
            x
          </button>
        </div>

        {/* Navigation Items */}
        <nav
          style={{
            flex: 1,
            padding: 'var(--space-4) 0',
          }}
        >
          <Link
            to="/"
            onClick={onClose}
            className="mobile-nav-link"
            style={navLinkStyle}
          >
            {t('home')}
          </Link>

          <Link
            to="/local"
            onClick={onClose}
            className="mobile-nav-link"
            style={navLinkStyle}
          >
            {t('localAssistant')}
          </Link>

          <Link
            to="/web"
            onClick={onClose}
            className="mobile-nav-link"
            style={navLinkStyle}
          >
            {t('webAssistant')}
          </Link>

          <Link
            to="/admin"
            onClick={onClose}
            className="mobile-nav-link"
            style={navLinkStyle}
          >
            {t('admin')}
          </Link>

          <a
            href="https://www.compudopt.org/tech-support"
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClose}
            className="mobile-nav-link"
            style={navLinkStyle}
          >
            {t('help')}
          </a>

          <a
            href="https://compudopt.org"
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClose}
            className="mobile-nav-link"
            style={navLinkStyle}
          >
            {t('about')}
          </a>
        </nav>

        {/* Footer */}
        <div
          style={{
            padding: 'var(--space-5)',
            borderTop: '1px solid var(--border-default)',
            color: 'var(--text-tertiary)',
            fontSize: 'var(--text-sm)',
            textAlign: 'center',
          }}
        >
          2025 Compudopt
        </div>
      </div>
    </>
  );
};

export default MobileNav;
